import apiClient from '@u/apiClient'
import apiClientDocument from '@u/apiClientDocument'
import GetCommissionNoteListController from '@/wayfinder/actions/App/Http/Controllers/CommissionNote/GetCommissionNoteListController'
import GetCommissionNoteByIdController from '@/wayfinder/actions/App/Http/Controllers/CommissionNote/GetCommissionNoteByIdController'
import GetCommissionNoteActivitiesByIdController from '@/wayfinder/actions/App/Http/Controllers/CommissionNote/GetCommissionNoteActivitiesByIdController'
import ExportCommissionNoteListController from '@/wayfinder/actions/App/Http/Controllers/CommissionNote/ExportCommissionNoteListController'
import PdfCommissionNoteListController from '@/wayfinder/actions/App/Http/Controllers/CommissionNote/PdfCommissionNoteListController'
import GetCommissionNoteMailDefaultsController from '@/wayfinder/actions/App/Http/Controllers/CommissionNote/GetCommissionNoteMailDefaultsController'
import GetCommissionNoteHeadersController from '@/wayfinder/actions/App/Http/Controllers/CommissionNote/GetCommissionNoteHeadersController'
import DeleteCommissionNoteController from '@/wayfinder/actions/App/Http/Controllers/CommissionNote/DeleteCommissionNoteController'
import PdfCommissionNoteController from '@/wayfinder/actions/App/Http/Controllers/CommissionNote/PdfCommissionNoteController'
import StoreCommissionNoteController from '@/wayfinder/actions/App/Http/Controllers/CommissionNote/StoreCommissionNoteController'
import GetCommissionNoteCandidatesController from '@/wayfinder/actions/App/Http/Controllers/CommissionNote/GetCommissionNoteCandidatesController'
import AddDocumentsToCommissionNoteController from '@/wayfinder/actions/App/Http/Controllers/CommissionNote/AddDocumentsToCommissionNoteController'
import ReincludeCommissionDocumentController from '@/wayfinder/actions/App/Http/Controllers/CommissionNote/ReincludeCommissionDocumentController'
import StoreCommissionNoteItemController from '@/wayfinder/actions/App/Http/Controllers/CommissionNote/StoreCommissionNoteItemController'
import UpdateCommissionNoteItemController from '@/wayfinder/actions/App/Http/Controllers/CommissionNote/UpdateCommissionNoteItemController'
import RestoreCommissionNoteItemController from '@/wayfinder/actions/App/Http/Controllers/CommissionNote/RestoreCommissionNoteItemController'
import DeleteCommissionNoteItemController from '@/wayfinder/actions/App/Http/Controllers/CommissionNote/DeleteCommissionNoteItemController'
import ReorderCommissionNoteItemsController from '@/wayfinder/actions/App/Http/Controllers/CommissionNote/ReorderCommissionNoteItemsController'
import UpdateCommissionNoteController from '@/wayfinder/actions/App/Http/Controllers/CommissionNote/UpdateCommissionNoteController'
import CancelCommissionNoteController from '@/wayfinder/actions/App/Http/Controllers/CommissionNote/CancelCommissionNoteController'
import CommissionNoteMailSentController from '@/wayfinder/actions/App/Http/Controllers/CommissionNote/CommissionNoteMailSentController'
import PayCommissionNoteController from '@/wayfinder/actions/App/Http/Controllers/CommissionNote/PayCommissionNoteController'

export default {
  fetchCommissionNoteList(_context, payload) {
    return apiClient
      .route(GetCommissionNoteListController.post(), payload)
      .then((response) => response.data)
  },
  fetchCommissionNote(_context, payload) {
    return apiClient
      .route(
        GetCommissionNoteByIdController.get({ commission_note: payload.id })
      )
      .then((response) => response.data)
  },
  fetchCommissionNoteActivities(_context, payload) {
    return apiClient
      .route(
        GetCommissionNoteActivitiesByIdController.get({
          commission_note: payload.id
        })
      )
      .then((response) => response.data)
  },
  // The exports answer { url }: a temporary file to open (Excel, CSV or PDF of the list)
  exportCommissionNoteList(_context, payload) {
    return apiClient
      .route(ExportCommissionNoteListController.post(), payload)
      .then((response) => response.data)
  },
  pdfCommissionNoteList(_context, payload) {
    return apiClient
      .route(PdfCommissionNoteListController.post(), payload)
      .then((response) => response.data)
  },
  // the PDF itself (blob), for the print page reader
  pdfCommissionNoteInline(_context, payload) {
    return apiClientDocument
      .route(
        PdfCommissionNoteController.get(
          { commission_note: payload.id },
          { query: { ...payload.options, inline: 1 } }
        ),
        { responseType: 'blob' }
      )
      .then((response) => response.data)
  },
  // { headers: [{ id, name, favorite }], footers: [{ id, name }] } of the agency and its company
  fetchCommissionNoteHeaders(_context, payload) {
    return apiClient
      .route(
        GetCommissionNoteHeadersController.get({ commission_note: payload.id })
      )
      .then((response) => response.data)
  },
  // { receivers: [{ id, name, email }], subject, message }
  fetchCommissionNoteMailDefaults(_context, payload) {
    return apiClient
      .route(
        GetCommissionNoteMailDefaultsController.get({
          commission_note: payload.id
        })
      )
      .then((response) => response.data)
  },
  updateCommissionNote(_context, payload) {
    return apiClient
      .route(
        UpdateCommissionNoteController.put({ commission_note: payload.id }),
        payload.data
      )
      .then((response) => response.data)
  },
  payCommissionNote(_context, payload) {
    return apiClient
      .route(PayCommissionNoteController.post({ commission_note: payload.id }))
      .then((response) => response.data)
  },
  // only an open note can be deleted: its documents become available again
  deleteCommissionNote(_context, payload) {
    return apiClient
      .route(
        DeleteCommissionNoteController.delete({ commission_note: payload.id })
      )
      .then((response) => response.data)
  },
  // Creates the open note of an advisor for an agency and a day, or answers the existing one:
  // { commission_note, created }
  storeCommissionNote(_context, payload) {
    return apiClient
      .route(StoreCommissionNoteController.post(), payload)
      .then((response) => response.data)
  },
  // The documents of the advisor and the agency of the note, on a period: { documents }
  fetchCommissionNoteCandidates(_context, payload) {
    return apiClient
      .route(
        GetCommissionNoteCandidatesController.post({
          commission_note: payload.id
        }),
        { from: payload.from, to: payload.to }
      )
      .then((response) => response.data)
  },
  addCommissionNoteDocuments(_context, payload) {
    return apiClient
      .route(
        AddDocumentsToCommissionNoteController.post({
          commission_note: payload.id
        }),
        { documents: payload.documents }
      )
      .then((response) => response.data)
  },
  reincludeCommissionDocument(_context, payload) {
    return apiClient
      .route(
        ReincludeCommissionDocumentController.post({
          invoice: payload.invoiceId
        })
      )
      .then((response) => response.data)
  },

  // Lines of an open note: each call answers the whole { commission_note }
  storeCommissionNoteItem(_context, payload) {
    return apiClient
      .route(
        StoreCommissionNoteItemController.post({
          commission_note: payload.id
        }),
        payload.data
      )
      .then((response) => response.data)
  },
  updateCommissionNoteItem(_context, payload) {
    return apiClient
      .route(
        UpdateCommissionNoteItemController.put({
          commission_note: payload.id,
          commission_note_item: payload.itemId
        }),
        payload.data
      )
      .then((response) => response.data)
  },
  restoreCommissionNoteItem(_context, payload) {
    return apiClient
      .route(
        RestoreCommissionNoteItemController.post({
          commission_note: payload.id,
          commission_note_item: payload.itemId
        })
      )
      .then((response) => response.data)
  },
  // A calculated line is deleted with a mode (release | exclude), a free line without
  deleteCommissionNoteItem(_context, payload) {
    return apiClient
      .route(
        DeleteCommissionNoteItemController.delete({
          commission_note: payload.id,
          commission_note_item: payload.itemId
        }),
        payload.mode ? { data: { mode: payload.mode } } : undefined
      )
      .then((response) => response.data)
  },
  reorderCommissionNoteItems(_context, payload) {
    return apiClient
      .route(
        ReorderCommissionNoteItemsController.put({
          commission_note: payload.id
        }),
        { items: payload.items }
      )
      .then((response) => response.data)
  },
  // The mail itself is sent by the mail window; this only writes the sending in the history of the note
  commissionNoteMailSent(_context, payload) {
    return apiClient
      .route(
        CommissionNoteMailSentController.post({
          commission_note: payload.id
        }),
        { receivers: payload.receivers }
      )
      .then((response) => response.data)
  },
  cancelCommissionNote(_context, payload) {
    return apiClient
      .route(
        CancelCommissionNoteController.post({ commission_note: payload.id })
      )
      .then((response) => response.data)
  }
}
